(function(){
	"use strict";

	angular
		.module('pwc.directives')
		.directive('confirmMatch', confirmMatch);

	function confirmMatch(){
		return {
			restrict : "A",

			require : "ngModel",

			scope: {
				compareValue: "=confirmMatch"
			},

			link : function(scope, element, attributes, ngModel) {

				ngModel.$validators.confirmMatch = function(modelValue) {
					return modelValue == scope.compareValue;
				};

				scope.$watch("compareValue", function() {
					ngModel.$validate();
				});
			}
		};
	}

})();